import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { Card, CardBody, CardFooter, CardHeader, Modal } from "@features/ui";
import { buttonTracking } from "@lib/tracking.helpers";

import "./erase-budget-confirmation.modal.scss";

const trackingId = "career-compare-erase-budget-confirmation-modal";

export const EraseBudgetConfirmationModal = ({
  career,
  onClose,
  onConfirm,
  onCancel,
  open,
}) => {
  const toolbar = (
    <Button
      icon={["fa-regular", "xmark"]}
      onClick={onClose}
      aria-label="close"
      {...buttonTracking(trackingId, "close")}
    />
  );

  return (
    <Modal
      key="career-compare-erase-budget-confirmation"
      modalClassName={"career-compare-erase-budget-confirmation-modal"}
      open={open}
      role="alertdialog"
    >
      <Card>
        <CardHeader title={<h1>Erase Budget?</h1>} toolbar={toolbar} />
        <CardBody>
          You already have a budget created for <strong>{career?.title}</strong>
          . Would you like to erase that and start a new budget? This can’t be
          undone.
        </CardBody>
        <CardFooter>
          <Button
            destructive
            onClick={onConfirm}
            {...buttonTracking(trackingId, "yes")}
          >
            Yes, continue
          </Button>
          <Button onClick={onCancel} {...buttonTracking(trackingId, "no")}>
            No, cancel
          </Button>
        </CardFooter>
      </Card>
    </Modal>
  );
};

EraseBudgetConfirmationModal.displayName = "Budget Warning Modal";

EraseBudgetConfirmationModal.propTypes = {
  career: PropTypes.shape({
    title: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  open: PropTypes.bool,
};
